// extracted by mini-css-extract-plugin
export default {"content__wrap":"ContentWrap_content__wrap__Q9pfo"};